class LinksConst {
	public static readonly CONTACT_US_FORM_LINK: string =
		"https://www.bria.ai/contact/";
	public static readonly BRIA_API: string = "https://briapi.redoc.ly/";
}

export default LinksConst;
